<button mat-icon-button class="close-button" (click)="close()">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
    <mat-card class="p-0">
        <form [formGroup]="produtoForm" (ngSubmit)="submit()" (keydown.enter)="$event.preventDefault()">
            <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="10px" fxLayoutGap.lt-sm="5px">
                <div fxFlex="100" class="pr-1"><br></div>


                <mat-tab-group>
                    <mat-tab label="Geral">
                        <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="10px" fxLayoutGap.lt-sm="5px">
                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" [style.min-width]="layoutConf.isMobile ? '100%' : '350px'">
                                    <mat-label>Classificação de Origem </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['classorigemId']!"
                                        style="min-width:350px;">
                                        <mat-option *ngFor="let origem of this.enums?.nforigem"
                                            [value]="origem?.codigo">
                                            {{origem?.codigo + ' - ' + origem?.descricao}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <!-- <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1"></div> -->

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" [style.min-width]="layoutConf.isMobile ? '100%' : '350px'">
                                    <mat-label>Classificação Tributária(CST/CSOSN) </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['classtributariaId']!"
                                        style="min-width:350px;">
                                        <mat-option *ngFor="let cst of this.enums?.cst_ICMS" [value]="cst?.codigo2">
                                            {{cst?.codigo + ' - ' + cst?.descricao}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" [style.min-width]="layoutConf.isMobile ? '100%' : '350px'">
                                    <mat-label>Classificação Tributária p/ não contribuinte(CST/CSOSN) </mat-label>
                                    <mat-select
                                        [formControl]="produtoForm?.controls['classtributariaNaoContribuinteId']!"
                                        style="min-width:350px;">
                                        <mat-option *ngFor="let cstNC of this.enums?.cst_ICMS" [value]="cstNC?.codigo2">
                                            {{cstNC?.codigo + ' - ' + cstNC?.descricao}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" [style.min-width]="layoutConf.isMobile ? '100%' : '350px'">
                                    <mat-label>Modalidade de determinação da BC do ICMS </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['modalidadeBcIcms']!">
                                        <mat-option *ngFor="let item of this.enums?.nfnotaInfoItemModalidadeBCICMS"
                                            [value]="item?.codigo" style="min-width:350px;">
                                            {{item?.codigo + ' - ' + item?.descricao}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" [style.min-width]="layoutConf.isMobile ? '100%' : '350px'">
                                    <mat-label>Modalidade de determinação da BC do ICMS ST </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['modalidadeBcIcmsSt']!"
                                        style="min-width:350px;">
                                        <mat-option *ngFor="let item of this.enums?.nfnotaInfoItemModalidadeBCICMSST"
                                            [value]="item?.codigo">
                                            {{item?.codigo + ' - ' + item?.descricao}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" [style.min-width]="layoutConf.isMobile ? '100%' : '350px'">
                                    <mat-label>Tipo de Benefício Fiscal </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['beneficioFiscal']!">
                                        <mat-option *ngFor="let item of this.enums?.tipoBeneficioFiscal"
                                            [value]="item?.codigo">
                                            {{item?.descricao}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" style="min-width:350px;">
                                    <input [imask]="maskUpper" matInput name="codigoBeneficioFiscalUF" matInput
                                        type="text" [formControl]="produtoForm?.controls['codigoBeneficioFiscalUF']!"
                                        placeholder="Código Benefício Fiscal">
                                </mat-form-field>
                                <small
                                    *ngIf="produtoForm?.controls['codigoBeneficioFiscalUF']?.hasError('required') && produtoForm?.controls['codigoBeneficioFiscalUF']?.touched"
                                    class="form-error-msg"> Código Benefício Fiscal é obrigatório </small>
                            </div>


                            <div fxFlex="80" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width">
                                    <mat-label>Classificação Fiscal de Saída </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['fatClassFiscal']" (selectionChange)="onSelectClassFiscal($event)">
                                        <mat-option>
                                            <ngx-mat-select-search [formControl]="produtoForm?.controls['searchClassFiscal']!"
                                                placeholderLabel="Pesquisar CLassificação Fiscal..." noEntriesFoundLabel="CLassificação Fiscal não encontrado" [searching]="searching">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let classFiscal of this.fatClassFiscais"
                                            [value]="classFiscal">
                                            <span>{{ classFiscal.id }}</span> -
                                            <span> {{classFiscal.descricao.trim()}}</span>
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
    
                            <div fxFlex="80" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width">
                                    <mat-label>Classificação Fiscal de Entrada </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['fatClassFiscalEntrada']" (selectionChange)="onSelectClassFiscalEntrada($event)">
                                        <mat-option>
                                            <ngx-mat-select-search [formControl]="produtoForm?.controls['searchClassFiscalEntrada']!"
                                                placeholderLabel="Pesquisar Classificação Fiscal..." noEntriesFoundLabel="Classificação Fiscal não encontrado" [searching]="searching">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let classFiscal of this.fatClassFiscaisEntrada"
                                            [value]="classFiscal">
                                            <span>{{ classFiscal.id }}</span> -
                                            <span> {{classFiscal.descricao.trim()}}</span>
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
    
                            <div fxFlex="100" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width">
                                    <mat-label>Classificação TIPI/NCM </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['classtipi']!" (selectionChange)="onSelectClassTipi($event)">
                                        <mat-option>
                                            <ngx-mat-select-search [formControl]="produtoForm?.controls['searchClasstipi']!"
                                                placeholderLabel="Pesquisar NCM..." noEntriesFoundLabel="NCM não encontrado" [searching]="searching">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let ncm of this.fatClassTipis" [value]="ncm">
                                            <span>{{ ncm.codigoNcm }}</span> -
                                            <span> {{ncm.descricao.trim()}}</span>
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width">
                                    <input [imask]="maskUpper" matInput name="cest" matInput type="text"
                                        [formControl]="produtoForm?.controls['cest']!"
                                        placeholder="Código Especificador da Substituição Tributária (CEST)">
                                </mat-form-field>
                                <small
                                    *ngIf="produtoForm?.controls['cest']?.hasError('required') && produtoForm?.controls['cest']?.touched"
                                    class="form-error-msg"> Código Especificador da Substituição Tributária (CEST) é
                                    obrigatório
                                </small>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" [style.min-width]="layoutConf.isMobile ? '100%' : '350px'">
                                    <mat-label>Tabela de alíquota de ICMS Normal </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['aliquotasNormalId']!">
                                        <mat-option *ngFor="let item of this.aliquotas?.aliquotas" [value]="item?.id">
                                            {{item?.classtributariaId + ' - ' + item?.descricao}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" [style.min-width]="layoutConf.isMobile ? '100%' : '350px'">
                                    <mat-label>Tabela de alíquota de INSS/FUNRURAL </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['aliqinssId']!">
                                        <mat-option *ngFor="let item of this.aliquotas?.aliquotaFUNRURAL"
                                            [value]="item?.id">
                                            {{item?.id + ' - ' + item?.descricao}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" [style.min-width]="layoutConf.isMobile ? '100%' : '350px'">
                                    <mat-label>Tabela de alíquota de IRRF </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['aliqirrfId']!">
                                        <mat-option *ngFor="let item of this.aliquotas?.aliquotaIRRF"
                                            [value]="item?.id">
                                            {{item?.id + ' - ' + item?.descricao}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" [style.min-width]="layoutConf.isMobile ? '100%' : '350px'">
                                    <mat-label>Tabela de alíquota de ICMS redução (Saída) </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['aliquotasReducaosId']!">
                                        <mat-option *ngFor="let item of this.aliquotas?.aliquotas" [value]="item?.id">
                                            {{item?.id + ' - ' + item?.descricao}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" [style.min-width]="layoutConf.isMobile ? '100%' : '350px'">
                                    <mat-label>Tabela de alíquota de ICMS redução (Entrada) </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['aliquotasReducaoeId']!">
                                        <mat-option *ngFor="let item of this.aliquotas?.aliquotas" [value]="item?.id">
                                            {{item?.id + ' - ' + item?.descricao}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" [style.min-width]="layoutConf.isMobile ? '100%' : '350px'">
                                    <mat-label>Tabela de alíquota de ICMS especial diferido </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['aliquotasDiferimentoId']!">
                                        <mat-option *ngFor="let item of this.aliquotas?.aliquotas" [value]="item?.id">
                                            {{item?.id + ' - ' + item?.descricao}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" [style.min-width]="layoutConf.isMobile ? '100%' : '350px'">
                                    <mat-label>Indicador de exigibilidade do ISSQN </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['indIss']!">
                                        <mat-option
                                            *ngFor="let item of this.enums?.nfnotaInfoItemIndicadorExigibilidadeISS"
                                            [value]="item?.codigo">
                                            {{item?.descricao}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>


                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" [style.min-width]="layoutConf.isMobile ? '100%' : '350px'">
                                    <mat-label>CST Para IPI Saída </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['cstIpiSaida']!"
                                        style="min-width:350px;">
                                        <mat-option *ngFor="let item of this.enums?.nfnotaInfoSituacaoTributariaIPI"
                                            [value]="item?.codigo">
                                            {{item?.codigo + ' - ' + item?.descricao}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" style="text-align:right">
                                    <input matInput name="aliquotaIpiSaida" matInput type="text"
                                        [formControl]="produtoForm?.controls['aliquotaIpiSaida']!"
                                        placeholder="Alíquota de IPI Saída" currencyMask
                                        [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }">
                                        <span matSuffix>%</span>
                                </mat-form-field>
                                <small
                                    *ngIf="produtoForm?.controls['aliquotaIpiSaida']?.hasError('required') && produtoForm?.controls['aliquotaIpiSaida']?.touched"
                                    class="form-error-msg"> Alíquota de IPI Saída é obrigatório </small>
                            </div>

                            
                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" [style.min-width]="layoutConf.isMobile ? '100%' : '350px'">
                                    <mat-label>CST para IPI Entrada </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['cstIpiEntrada']!"
                                        style="min-width:350px;">
                                        <mat-option *ngFor="let item of this.enums?.nfnotaInfoSituacaoTributariaIPI"
                                            [value]="item?.codigo">
                                            {{item?.codigo + ' - ' + item?.descricao}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" style="text-align:right">
                                    <input matInput name="aliquotaIpiEntrada" matInput type="text" step="any"
                                        (focus)="$event.target.select()"
                                        [formControl]="produtoForm.controls['aliquotaIpiEntrada']"
                                        placeholder="Alíquota de IPI Entrada"  currencyMask
                                        [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }">
                                        <span matSuffix>%</span>
                                </mat-form-field>
                                <small
                                    *ngIf="produtoForm?.controls['aliquotaIpiEntrada']?.hasError('required') && produtoForm?.controls['aliquotaIpiEntrada']?.touched"
                                    class="form-error-msg"> Alíquota de IPI Entrada é obrigatório </small>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" [style.min-width]="layoutConf.isMobile ? '100%' : '350px'">
                                    <mat-label>CST para COFINS </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['cstCofins']!"
                                        style="min-width:350px;">
                                        <mat-option *ngFor="let item of this.enums?.nfnotaInfoSituacaoTributariaCOFINS"
                                            [value]="item?.codigo">
                                            {{item?.codigo + ' - ' + item?.descricao}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" style="text-align:right">
                                    <input matInput name="aliquotaCofins" matInput type="text" step="any"
                                        (focus)="$event.target.select()"
                                        [formControl]="produtoForm.controls['aliquotaCofins']"
                                        placeholder="Alíquota de COFINS" currencyMask
                                        [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }">
                                        <span matSuffix>%</span>
                                </mat-form-field>
                                <small
                                    *ngIf="produtoForm?.controls['aliquotaCofins']?.hasError('required') && produtoForm?.controls['aliquotaCofins']?.touched"
                                    class="form-error-msg"> Alíquota de COFINS é obrigatório </small>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" [style.min-width]="layoutConf.isMobile ? '100%' : '350px'">
                                    <mat-label>CST Para PIS </mat-label>
                                    <mat-select [formControl]="produtoForm?.controls['cstPis']!"
                                        style="min-width:350px;">
                                        <mat-option *ngFor="let item of this.enums?.nfnotaInfoSituacaoTributariaPIS"
                                            [value]="item?.codigo">
                                            {{item?.codigo + ' - ' + item?.descricao}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" style="text-align:right">
                                    <input matInput name="aliquotaPis" matInput type="text" step="any"
                                        (focus)="$event.target.select()"
                                        [formControl]="produtoForm.controls['aliquotaPis']" currencyMask
                                        [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }">
                                        <span matSuffix>%</span>
                                </mat-form-field>
                                <small
                                    *ngIf="produtoForm?.controls['aliquotaPis']?.hasError('required') && produtoForm?.controls['aliquotaPis']?.touched"
                                    class="form-error-msg"> Alíquota de PIS é obrigatório </small>
                            </div>

                            

                        </div>
                    </mat-tab>

                    <mat-tab label="Combustível">
                        <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="10px" fxLayoutGap.lt-sm="5px">
                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" style="min-width:50px;">
                                    <input [imask]="maskUpper" matInput name="codigoanp" matInput
                                        type="text" [formControl]="produtoForm?.controls['codigoanp']!"
                                        placeholder="Código ANP">
                                </mat-form-field>
                                <small
                                    *ngIf="produtoForm?.controls['codigoanp']?.hasError('required') && produtoForm?.controls['codigoanp']?.touched"
                                    class="form-error-msg"> Código ANP </small>
                            </div>
                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1"></div>
                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" style="min-width:50px;">
                                    <input [imask]="maskUpper" matInput name="combNumeroBico" matInput
                                        type="text" [formControl]="produtoForm?.controls['combNumeroBico']!"
                                        placeholder="Número de Bico">
                                </mat-form-field>
                                <small
                                    *ngIf="produtoForm?.controls['combNumeroBico']?.hasError('required') && produtoForm?.controls['combNumeroBico']?.touched"
                                    class="form-error-msg"> Número de Bico </small>
                            </div>
                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" style="min-width:50px;">
                                    <input [imask]="maskUpper" matInput name="combNumeroTanque" matInput
                                        type="text" [formControl]="produtoForm?.controls['combNumeroTanque']!"
                                        placeholder="Número de Tanque">
                                </mat-form-field>
                                <small
                                    *ngIf="produtoForm?.controls['combNumeroTanque']?.hasError('required') && produtoForm?.controls['combNumeroTanque']?.touched"
                                    class="form-error-msg"> Número de Tanque </small>
                            </div>
                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" style="min-width:50px;">
                                    <input [imask]="maskUpper" matInput name="percentualGLP" matInput
                                        type="text" [formControl]="produtoForm?.controls['percentualGLP']!"
                                        placeholder="(%) Percentual de GLP" currencyMask
                                        [options]="{ prefix: '% ', thousands: '.', decimal: ',' }">
                                </mat-form-field>
                                <small
                                    *ngIf="produtoForm?.controls['percentualGLP']?.hasError('required') && produtoForm?.controls['percentualGLP']?.touched"
                                    class="form-error-msg"> (%) Percentual de GLP </small>
                            </div>
                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" style="min-width:50px;">
                                    <input [imask]="maskUpper" matInput name="percentualGasNatural" matInput
                                        type="text" [formControl]="produtoForm?.controls['percentualGasNatural']!"
                                        placeholder="(%) Percentual de Gas Natural" currencyMask
                                        [options]="{ prefix: '% ', thousands: '.', decimal: ',' }">
                                </mat-form-field>
                                <small
                                    *ngIf="produtoForm?.controls['percentualGasNatural']?.hasError('required') && produtoForm?.controls['percentualGasNatural']?.touched"
                                    class="form-error-msg"> (%) Percentual de Gas Natural </small>
                            </div>
                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" style="min-width:50px;">
                                    <input [imask]="maskUpper" matInput name="percentualGasNaturalImportado" matInput
                                        type="text" [formControl]="produtoForm?.controls['percentualGasNaturalImportado']!"
                                        placeholder="(%) Percentual de Gas Natural Importado" currencyMask
                                        [options]="{ prefix: '% ', thousands: '.', decimal: ',' }">
                                </mat-form-field>
                                <small
                                    *ngIf="produtoForm?.controls['percentualGasNaturalImportado']?.hasError('required') && produtoForm?.controls['percentualGasNaturalImportado']?.touched"
                                    class="form-error-msg"> (%) Percentual de Gás Natural Importado </small>
                            </div>
                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" style="min-width:50px;">
                                    <input [imask]="maskUpper" matInput name="valorPar" matInput
                                        type="text" [formControl]="produtoForm?.controls['valorPar']!"
                                        placeholder="Valor Partida" currencyMask
                                        [options]="{ prefix: '', thousands: '.', decimal: ',' }">
                                </mat-form-field>
                                <small
                                    *ngIf="produtoForm?.controls['valorPar']?.hasError('required') && produtoForm?.controls['valorPar']?.touched"
                                    class="form-error-msg"> Valor Partida </small>
                            </div>
                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" style="min-width:50px;">
                                    <input [imask]="maskUpper" matInput name="valorUnitBcIcmsStRetUltComp" matInput
                                        type="text" [formControl]="produtoForm?.controls['valorUnitBcIcmsStRetUltComp']!"
                                        placeholder="Valor Base e Cálculo ICM-ST de retorno da Ultima Compra" currencyMask
                                        [options]="{ prefix: '', thousands: '.', decimal: ',' }">
                                </mat-form-field>
                                <small
                                    *ngIf="produtoForm?.controls['valorUnitBcIcmsStRetUltComp']?.hasError('required') && produtoForm?.controls['valorUnitBcIcmsStRetUltComp']?.touched"
                                    class="form-error-msg">Valor Base e Cálculo ICM-ST de retorno da Ultima Compra </small>
                            </div>
                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1"></div>
                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" style="min-width:50px;">
                                    <input [imask]="maskUpper" matInput name="valorUnitIcmsStRetUltComp" matInput
                                        type="text" [formControl]="produtoForm?.controls['valorUnitIcmsStRetUltComp']!"
                                        placeholder="Valor ICM-ST de retorno da Ultima Compra" currencyMask
                                        [options]="{ prefix: '', thousands: '.', decimal: ',' }">
                                </mat-form-field>
                                <small
                                    *ngIf="produtoForm?.controls['valorUnitIcmsStRetUltComp']?.hasError('required') && produtoForm?.controls['valorUnitIcmsStRetUltComp']?.touched"
                                    class="form-error-msg">Valor ICM-ST de retorno da Ultima Compra </small>
                            </div>
                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1"></div>
                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" style="min-width:50px;">
                                    <input [imask]="maskUpper" matInput name="valorUnitBcIcmsStDestUltComp" matInput
                                        type="text" [formControl]="produtoForm?.controls['valorUnitBcIcmsStDestUltComp']!"
                                        placeholder="Valor Base e Cálculo ICM-ST de Destino da Ultima Compra" currencyMask
                                        [options]="{ prefix: '', thousands: '.', decimal: ',' }">
                                </mat-form-field>
                                <small
                                    *ngIf="produtoForm?.controls['valorUnitBcIcmsStDestUltComp']?.hasError('required') && produtoForm?.controls['valorUnitBcIcmsStDestUltComp']?.touched"
                                    class="form-error-msg">Valor Base e Cálculo ICM-ST de Destino da Ultima Compra </small>
                            </div>
                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1"></div>
                            <div fxFlex="50" fxFlex.lt-sm="100" class="pr-1">
                                <mat-form-field class="full-width" style="min-width:50px;">
                                    <input matInput name="valorUnitIcmsStDestUltComp" type="text"
                                        [formControl]="produtoForm?.controls['valorUnitIcmsStDestUltComp']!"
                                        placeholder="Valor ICM-ST de Destino da Ultima Compra" currencyMask
                                        [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                                </mat-form-field>
                                <small
                                    *ngIf="produtoForm?.controls['valorUnitIcmsStDestUltComp']?.hasError('required') && produtoForm?.controls['valorUnitIcmsStDestUltComp']?.touched"
                                    class="form-error-msg">Valor ICM-ST de Destino da Ultima Compra </small>
                            </div>
                        </div>
                    </mat-tab>

                    <mat-tab label="CTS por Estado">
                        <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="10px" fxLayoutGap.lt-sm="5px">
                            <div fxFlex="25" class="pr-1">
                                <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="10px" fxLayoutGap.lt-sm="5px">
                                    <mat-form-field>
                                        <mat-label> Estado </mat-label>
                                        <mat-select [(ngModel)]='this.selectedEstado'
                                            [ngModelOptions]="{standalone: true}">
                                            <mat-option *ngFor="let est of this.estados" [value]="est">
                                                {{est.estado + ' - ' + est.uf}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div fxFlex="25" class="pr-1">
                                <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="10px" fxLayoutGap.lt-sm="5px">
                                    <mat-form-field>
                                        <mat-label> CST </mat-label>
                                        <mat-select [(ngModel)]='this.cstContrib' [ngModelOptions]="{standalone: true}">
                                            <mat-option *ngFor="let cst of this.enums?.cst_ICMS" [value]="cst">
                                                {{cst.codigo + ' - ' + cst.descricao}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div fxFlex="25" class="pr-1">
                                <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="10px" fxLayoutGap.lt-sm="5px">
                                    <mat-form-field>
                                        <mat-label> CST p/ não contribuinte </mat-label>
                                        <mat-select [(ngModel)]='this.cstNaoContrib'
                                            [ngModelOptions]="{standalone: true}">
                                            <mat-option *ngFor="let cst_n of this.enums?.cst_ICMS" [value]="cst_n">
                                                {{cst_n.codigo + ' - ' + cst_n.descricao}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div fxFlex="25" class="pr-1">
                                <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="10px" fxLayoutGap.lt-sm="5px">
                                    <button-loading [loadingText]="'Salvando...'" color="primary" [loading]="isAdding"
                                        (click)=" $event.preventDefault();this.addCstEstado()">{{"ADD" | translate }}
                                    </button-loading>
                                    <!-- <button mat-raised-button color="primary"
                            [disabled]="this.selectedEstado===undefined||this.cstContrib===undefined||this.cstNaoContrib===undefined"
                            (click)=" $event.preventDefault();this.addCstEstado()">{{"ADD" | translate }}</button> -->
                                </div>
                            </div>
                            <div fxFlex="100" class="pr-1">
                                <ngx-datatable class="material ml-0 mr-0" [rows]="this.classTribs$ | async"
                                    [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true"
                                    [messages]="{emptyMessage:'Nenhuma Classificação encontrada por estado'}"
                                    [rowHeight]="50">
                                    <ngx-datatable-column name="#" [width]="25">
                                        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                            <strong>{{ rowIndex+1 }}</strong>
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column name="Opções" [flexGrow]="1" [width]="80">
                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                            <div style="display:flex; align-items:center; justify-content:center; height:100%;">
                                                <button mat-icon-button (click)="$event.preventDefault();this.deleteCst(row.id)">
                                                    <mat-icon class="close-icon" color="warn">delete</mat-icon>
                                                </button>
                                            </div>
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column name="Estado" [flexGrow]="1" [width]="175">
                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                            {{ this.readEstado(row.uf)}}
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column name="CST contribuinte" [flexGrow]="1" [width]="260">
                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                            {{ this.readCst(row?.classtributariaId) }}
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column name="CST não contribuinte" [flexGrow]="1" [width]="260">
                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                            {{ this.readCst(row?.classtributariaNaoContribuinteId) }}
                                        </ng-template>
                                    </ngx-datatable-column>
                                    
                                </ngx-datatable>
                            </div>
                        </div>
                    </mat-tab>
                </mat-tab-group>



            </div>
        </form>
    </mat-card>
</div>
<mat-dialog-actions>
    <div fxFlex="100" class="mt-1">
        <button class="mb-8" mat-raised-button [matTooltip]="'Salvar Lançamento'" color="primary"
            (click)="this.save();$event.preventDefault();">
            <mat-icon>save</mat-icon>{{"SAVE" |
            translate }}
        </button>
        <span fxFlex></span>
        <button mat-button color="warn" type="button" (click)="close()">
            <mat-icon>close</mat-icon>{{"CLOSE" | translate }}
        </button>
    </div>
</mat-dialog-actions>